import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue";
import { computed, useSlots } from 'vue';
export default {
  __name: 'LlSecondaryButton',
  props: {
    prependIcon: String,
    color: {
      type: String,
      default: 'control-surface'
    },
    variant: {
      type: String,
      default: 'flat'
    },
    isSaving: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default'
    },
    icon: {
      type: [String, Boolean],
      default: false
    },
    text: {
      type: Boolean,
      default: false
    },
    dataCy: {
      type: String,
      default: ''
    }
  },
  emits: ['click', 'btnClick'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;

    /**
     * The neutral fill is 1.09:1 against white — without a border the button is
     * invisible on a dim screen. The rule lives in src/css/style.css because it
     * needs `:hover`, which LL020 will not let a component carry in a <style> block.
     * Only the neutral treatment gets it: a coloured fill or an outlined variant
     * already has its own boundary.
     */
    const isNeutral = computed(() => props.color === 'control-surface');
    const usesNeutralTreatment = computed(() => props.variant === 'flat' && isNeutral.value);

    // Outlined, text and tonal draw their label in `color`, and the neutral fill
    // drawn as a label is near-white. So with no colour given those variants skip
    // Vuetify's colour and take a dark label (and, outlined, the control border).
    const usesNeutralUnfilled = computed(() => isNeutral.value && ['outlined', 'text', 'tonal'].includes(props.variant));

    // An icon with no label is an icon button: Vuetify's round shape, not a
    // rectangle with an icon in it. Needs an aria-label from the caller.
    const slots = useSlots();
    const iconOnly = computed(() => Boolean(props.icon) && !slots.default);
    const emit = __emit;
    const handleClick = event => {
      emit('click', event);
      emit('btnClick', event);
    };
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_btn = _resolveComponent("v-btn");
      return _openBlock(), _createBlock(_component_v_btn, {
        icon: iconOnly.value || undefined,
        variant: __props.variant,
        color: usesNeutralUnfilled.value ? undefined : __props.color,
        text: __props.text,
        disabled: __props.disabled,
        loading: __props.loading || __props.isSaving,
        size: __props.size,
        class: _normalizeClass({
          'll-secondary-button--neutral': usesNeutralTreatment.value,
          'll-secondary-button--neutral-unfilled': usesNeutralUnfilled.value
        }),
        "data-cy": __props.dataCy,
        tabindex: __props.disabled ? -1 : 0,
        onClick: handleClick
      }, {
        default: _withCtx(() => [__props.icon ? (_openBlock(), _createBlock(_component_v_icon, {
          key: 0
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.icon), 1)]),
          _: 1
        })) : __props.isSaving || __props.loading ? (_openBlock(), _createBlock(_component_v_icon, {
          key: 1,
          class: "mr-2 spin-animation"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("mdi-cog", -1)]))]),
          _: 1
        })) : __props.prependIcon ? (_openBlock(), _createBlock(_component_v_icon, {
          key: 2,
          class: "mr-2"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.prependIcon), 1)]),
          _: 1
        })) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default")]),
        _: 3
      }, 8, ["icon", "variant", "color", "text", "disabled", "loading", "size", "class", "data-cy", "tabindex"]);
    };
  }
};